import { Avatar, Divider, Drawer, Collapse, Icon, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, useMediaQuery, useTheme, styled, alpha, } from '@mui/material';
import { Box } from '@mui/system';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useNavigate, useLocation, } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useAppThemeContext, useAuthContext, useDrawerContext, } from '../../contexts';
import { Environment } from '../../environment';
import { DialogPefilFoto } from './DialogPefilFoto';
import { DialogPefil } from './DialogPerfil';

// ⭐ ALTERAÇÃO - função para pegar o primeiro trecho da rota
const getBaseRoute = (path: string) => {
  const parts = path.split('/').filter(Boolean);
  return parts[0] || '';
};
const ElegantDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: theme.spacing(32),
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.background.default, 0.95)
        : alpha(theme.palette.background.paper, 0.95),
    backdropFilter: 'blur(8px)',
    borderRight: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  },
}));
const ScrollContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: `${alpha(theme.palette.text.primary, 0.25)} transparent`,
  '&::-webkit-scrollbar': {
    width: '5px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(theme.palette.text.primary, 0.25),
    borderRadius: 8,
    transition: 'background-color 0.3s ease',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(theme.palette.text.primary, 0.45),
  },
}));

const CleanListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  margin: theme.spacing(0.5, 1),
  padding: theme.spacing(1.5, 2),
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.main, 0.16),
    fontWeight: 600,
  },
}));
const CleanSubItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  margin: theme.spacing(0.25, 1),
  paddingLeft: theme.spacing(4),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));
const GroupContainer = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0.5, 1),
  borderRadius: theme.spacing(1.5),
  transition: 'background-color 0.25s ease',

  '&.active': {
    backgroundColor: alpha(theme.palette.primary.main, 0.14),
    boxShadow: `inset 4px 0 0 ${theme.palette.primary.main}`,
  },
}));
interface IListItemLinkProps {
  to: string;
  icon: string;
  label: string;
  subItems?: Array<{ label: string; icon: string; to: string }>;
  openItemIndex: string | null;
  setOpenItemIndex: (index: string | null) => void;
  onClick?: () => void;
}
const ListItemLink: React.FC<IListItemLinkProps> = ({
  to,
  icon,
  label,
  subItems,
  openItemIndex,
  setOpenItemIndex,
  onClick,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const currentBase = getBaseRoute(location.pathname);
  const itemBase = getBaseRoute(to);

  const isActive = currentBase === itemBase;
  useEffect(() => {
    // ⭐ ALTERAÇÃO
    if (
      subItems?.some(
        (item) =>
          getBaseRoute(location.pathname) === getBaseRoute(item.to)
      )
    ) {
      setOpenItemIndex(to);
    }
  }, [location.pathname]);
  const handleClick = () => {
    if (subItems?.length) {
      setOpenItemIndex(openItemIndex === to ? null : to);
    } else {
      navigate(to);
      onClick?.();
    }
  };
  return (
    <GroupContainer className={openItemIndex === to ? 'active' : ''}>
      <CleanListItemButton selected={isActive} onClick={handleClick}>
        <ListItemIcon sx={{ minWidth: 40 }}>
          <Icon
            sx={{
              color: isActive
                ? theme.palette.primary.main
                : alpha(theme.palette.text.primary, 0.8),
            }}
          >
            {icon}
          </Icon>
        </ListItemIcon>

        <ListItemText primary={label} />

        {subItems &&
          (openItemIndex === to ? <ExpandLess /> : <ExpandMore />)}
      </CleanListItemButton>

      {subItems && (
        <Collapse in={openItemIndex === to} timeout="auto" unmountOnExit>
          <Box sx={{ px: 1, pb: 0.5 }}>
            {subItems.map((sub) => {

              // ⭐ ALTERAÇÃO
              const subActive =
                getBaseRoute(location.pathname) === getBaseRoute(sub.to);

              return (
                <CleanSubItemButton
                  key={sub.to}
                  selected={subActive}
                  onClick={() => {
                    navigate(sub.to);
                    onClick?.();
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Icon
                      sx={{
                        color: subActive
                          ? theme.palette.primary.main
                          : alpha(theme.palette.text.primary, 0.7),
                      }}
                    >
                      {sub.icon}
                    </Icon>
                  </ListItemIcon>

                  <ListItemText primary={sub.label} />
                </CleanSubItemButton>
              );
            })}
          </Box>
        </Collapse>
      )}
    </GroupContainer>
  );
};
interface IMenuLateralProps {
  children: React.ReactNode;
}
export const MenuLateral: React.FC<IMenuLateralProps> = ({ children }) => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [openItemIndex, setOpenItemIndex] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openFoto, setOpenFoto] = useState(false);
  const [openPerfil, setOpenPerfil] = useState(false);
  const [fotoPerfil, setFotoPerfil] = useState('');
  const [idUser, setIdUser] = useState('');
  const openMenu = Boolean(anchorEl);
  const { isDrawerOpen, toggleDrawerOpen, drawerOptions, drawerItemOptions } =
    useDrawerContext();
  const { toggleTheme } = useAppThemeContext();
  const { logout } = useAuthContext();
  interface JwtPayload {
    iduser: string;
    img: string;
  }

  useEffect(() => {
    const token = localStorage.getItem('APP_ACCESS_TOKEN');
    if (token) {
      const decoded = jwtDecode<JwtPayload>(token);
      setFotoPerfil(Environment.URL_IMGUSUARIOS + decoded.img);
      setIdUser(decoded.iduser);
    }
  }, []);

  return (
    <>
      <ElegantDrawer
        open={isDrawerOpen}
        variant={smDown ? 'temporary' : 'permanent'}
        onClose={toggleDrawerOpen}
      >
        <Box height="100%" display="flex" flexDirection="column">
          <Box
            height={theme.spacing(14)}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            sx={{ pt: 2, pb: 1 }}
          >
            <Avatar
              src={fotoPerfil}
              onClick={(e) => setAnchorEl(e.currentTarget)}
              sx={{
                width: theme.spacing(10),
                height: theme.spacing(10),
                cursor: 'pointer',
                border: `2px solid ${alpha(theme.palette.primary.main, 0.25)}`,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />

            <Menu
              anchorEl={anchorEl}
              open={openMenu}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem
                onClick={() => {
                  setOpenFoto(true);
                  setAnchorEl(null);
                }}
              >
                <Icon sx={{ mr: 1 }}>photo_camera</Icon>
                Foto do Perfil
              </MenuItem>

              <MenuItem
                onClick={() => {
                  setOpenPerfil(true);
                  setAnchorEl(null);
                }}
              >
                <Icon sx={{ mr: 1 }}>person</Icon>
                Perfil
              </MenuItem>
            </Menu>
          </Box>
          <Divider />
          <ScrollContainer>
            <List disablePadding>
              {drawerOptions.map((drawer) => (
                <ListItemLink
                  key={drawer.path}
                  to={drawer.path}
                  icon={drawer.icon}
                  label={drawer.label}
                  subItems={drawerItemOptions
                    .filter((i) => i.parent === drawer.path)
                    .map((i) => ({
                      label: i.label,
                      icon: i.icon,
                      to: i.path,
                    }))}
                  openItemIndex={openItemIndex}
                  setOpenItemIndex={setOpenItemIndex}
                  onClick={smDown ? toggleDrawerOpen : undefined}
                />
              ))}
            </List>
          </ScrollContainer>
          <Divider />
          <List>
            <CleanListItemButton onClick={toggleTheme}>
              <ListItemIcon>
                <Icon>
                  {theme.palette.mode === 'dark'
                    ? 'light_mode'
                    : 'dark_mode'}
                </Icon>
              </ListItemIcon>
              <ListItemText primary="Alternar Tema" />
            </CleanListItemButton>

            <CleanListItemButton onClick={logout}>
              <ListItemIcon>
                <Icon>exit_to_app</Icon>
              </ListItemIcon>
              <ListItemText primary="Sair" />
            </CleanListItemButton>
          </List>
        </Box>
      </ElegantDrawer>
      <DialogPefilFoto
        id={idUser}
        img={fotoPerfil}
        value=""
        open={openFoto}
        onClose={() => setOpenFoto(false)}
      />

      <DialogPefil
        id={idUser}
        value=""
        open={openPerfil}
        onClose={() => setOpenPerfil(false)}
      />
      <Box
        height="100vh"
        marginLeft={smDown ? 0 : theme.spacing(32)}
        sx={{ transition: 'margin 0.3s' }}
      >
        {children}
      </Box>
    </>
  );
};
